import { memo, useRef, useState } from 'react'
import { useHomeStore } from 'context/HomeStore'
import { deepCopyObject } from 'lib/utils'
import LockUnlockUserModal from 'components/modals/LockUnlockUser.modal'
import { ErrorBoundary } from 'asterX-UI'
import { useRoutes } from 'hooks'
import { EDIT_USER_PATH } from 'routes/constants.routes'
import { ImportTouchDesk } from 'modules/ImortTouchDesk'

const INITIAL_STATE = {
  open: false,
  user: null,
  isActive: false
}
const ListUsers = ({ isMobile }) => {
  const _isMounted = useRef(true)
  const { homeStore, homeStoreFunc } = useHomeStore()
  const [lockUnlockUser, setLockUnlockUser] = useState(INITIAL_STATE)
  const { goTo } = useRoutes()
  const onOpenLockUnlockUser = (user, isActive) => () => {
    setLockUnlockUser({
      open: true,
      user,
      isActive
    })
  }

  const onCloseLockUnlockUser = () => {
    setLockUnlockUser(deepCopyObject(INITIAL_STATE))
  }

  const onSaveLockUnlockUser = (user, isActive) => {
    if (!isActive) {
      user.subdivision = ''
    }
    homeStoreFunc.onLockUnlockUser(user.id, isActive)
    onCloseLockUnlockUser()
  }

  const onEditUser = id => () => {
    goTo(`${EDIT_USER_PATH}/${id}`)
  }

  const userProps = {
    users: homeStore.users || [],
    onClickLockUnlock: onOpenLockUnlockUser,
    onEditUser
  }

  return (
    <ErrorBoundary>
      <ImportTouchDesk
        touch={() => import('./layout/ListUsers.mobile')}
        desktop={() => import('./layout/ListUsers.desktop')}
      >
        {Component => <Component {...userProps} />}
      </ImportTouchDesk>

      {lockUnlockUser.open && (
        <LockUnlockUserModal
          onClose={onCloseLockUnlockUser}
          onSave={onSaveLockUnlockUser}
          {...lockUnlockUser}
        />
      )}
    </ErrorBoundary>
  )
}
export default memo(ListUsers)
